export default "__VITE_ASSET__BPnbRrRd__"